const comments = [
  {
    name: '清风徐来',
    avatar: 'https://readdy.ai/api/search-image?query=A%20clean%20simple%20user%20avatar%20in%20warm%20coral%20tone%20gradient%20with%20soft%20circular%20shape%2C%20minimalist%20design%2C%20gentle%20lighting%2C%20centered%20composition&width=80&height=80&seq=avatar-c1&orientation=squarish',
    role: '资深创作者',
    time: '2小时前',
    content: '海角网的原创氛围真的太棒了！在这里发表作品总能收到大量真诚的反馈，社区互动非常活跃。加入三年，创作了上百部作品，收获了很多志同道合的朋友。',
    likes: 1286,
  },
  {
    name: '夜空守望者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20clean%20simple%20user%20avatar%20in%20warm%20amber%20tone%20gradient%20with%20soft%20circular%20shape%2C%20minimalist%20design%2C%20gentle%20lighting%2C%20centered%20composition&width=80&height=80&seq=avatar-c2&orientation=squarish',
    role: '社区达人',
    time: '5小时前',
    content: '每天最大的快乐就是打开海角网看最新更新。视频区的资源更新速度很快，论坛里的讨论也特别有深度。官网入口稳定，体验一直很流畅。',
    likes: 953,
  },
  {
    name: '墨染江南',
    avatar: 'https://readdy.ai/api/search-image?query=A%20clean%20simple%20user%20avatar%20in%20warm%20rose%20tone%20gradient%20with%20soft%20circular%20shape%2C%20minimalist%20design%2C%20gentle%20lighting%2C%20centered%20composition&width=80&height=80&seq=avatar-c3&orientation=squarish',
    role: '新晋会员',
    time: '昨天',
    content: '朋友推荐的海角网，一用就爱上了！内容分类清晰，海角社区网站界面也很友好。海角社的各类专题做得特别用心，每次浏览都有新发现。',
    likes: 467,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            读者心声
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            来自海角社区真实用户的声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <article
              key={comment.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.role} · {comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-1 mt-4 text-xs text-foreground-400">
                <i className="ri-heart-line"></i>
                <span>{comment.likes}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}